module.exports = __webpack_public_path__ + "img/Banner_CaaS(EN).149498af.png";